import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAMES } from '../constants';
import {
  ONBOARDING_FLOW_VERSIONS,
  OnboardingFlowVersion,
} from '@/constants/features/onboarding';

interface OnboardingState {
  isOpen: boolean;
  currentStepNumber: number;
  flowVersion: OnboardingFlowVersion;
}

const initialState: OnboardingState = {
  isOpen: false,
  currentStepNumber: 1,
  flowVersion: ONBOARDING_FLOW_VERSIONS.DEFAULT,
};

const onboardingSlice = createSlice({
  name: SLICE_NAMES.ONBOARDING,
  initialState,
  reducers: {
    openOnboarding: (state, action: PayloadAction<OnboardingFlowVersion>) => {
      state.isOpen = true;
      state.currentStepNumber = 1;
      state.flowVersion = action.payload;
    },
    closeOnboarding: state => {
      state.isOpen = false;
      state.currentStepNumber = 1;
    },
    setOnboardingStepNumber: (state, action: PayloadAction<number>) => {
      state.currentStepNumber = action.payload;
    },
  },
});

export const { openOnboarding, closeOnboarding, setOnboardingStepNumber } =
  onboardingSlice.actions;
export const onboardingReducer = onboardingSlice.reducer;
